// extracted by mini-css-extract-plugin
export default {"iconContainer":"plan-suggestion_iconContainer__cmN3h","icon":"plan-suggestion_icon__nnE44","textContainer":"plan-suggestion_textContainer__WB4Zy"};